import React from 'react'
import { Button } from '@demandlocal/components'
import { useModal } from '../../components/useModal'
import { FieldValues, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import axios from 'axios'
import { useUpdateDealerVaultPartners } from '../../api/admin/partners/useUpdateDealerVaultPartners'

export default function AdminUpdateDealerVault(): JSX.Element {
  const { closeModal } = useModal()
  const formContext = useForm({
    mode: 'onSubmit',
  })
  const { setValue, reset, handleSubmit } = formContext
  const { mutateAsync } = useUpdateDealerVaultPartners()

  const onSubmit = async (values: Partial<FieldValues>): Promise<void> => {
    const toastId = toast.loading('Uploading...')
    try {
      if (values?.file.type !== 'text/csv') {
        toast.error('Incorrect File type', { id: toastId, duration: 5000 })
        return
      } else {
        const data = await axios.get(values?.file.src)
        const headers = data.data
          .split('\n')[0]
          .split(',')
          .map((s) => s.replace(/[^a-zA-Z0-9 ]/g, ''))

        const result = data.data
          .split('\n')
          .slice(1)
          .map((line) => {
            const parsedLine = {}
            const currentLine = line.split(',')
            headers.forEach(
              (h, i) =>
                (parsedLine[h] = JSON.parse(currentLine[i]).replace(
                  /[^a-zA-Z0-9 \/:]/g,
                  '',
                )),
            )
            return parsedLine
          })

        await mutateAsync({ data: result })
        toast.success(
          'Succesfully Updated DealerVault Partners. Please refresh to see changes',
          {
            id: toastId,
            duration: 5000,
          },
        )
        closeModal()
      }
    } catch (err) {
      toast.error('Error Uploading File', { id: toastId, duration: 5000 })
    }
  }

  return (
    <div className="flex flex-col px-5 py-10 gap-5 w-full">
      <span className="text-primary-xiketic font-bold text-lg border-b-2 pb-3">
        Upload a file to update the DealerVault partners list
      </span>
      <div className="flex flex-col flex-grow">
        <input
          type="file"
          onChange={(e) => {
            if (e.target.files && e.target.files.length > 0) {
              setValue(
                'file',
                {
                  src: URL.createObjectURL(e.target.files[0]),
                  type: e.target.files[0].type,
                  file: e.target.files[0],
                },
                { shouldDirty: true },
              )
            }
          }}
        />
      </div>
      <div className="flex flex-row justify-between border-t-2 pt-3">
        <Button
          type="reset"
          variant="secondary"
          onClick={() => {
            reset()
            closeModal()
          }}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" onClick={handleSubmit(onSubmit)}>
          Upload
        </Button>
      </div>
    </div>
  )
}
